import { render, staticRenderFns } from "./ModuleClients.vue?vue&type=template&id=226f1190&scoped=true&lang=pug&"
import script from "./ModuleClients.vue?vue&type=script&lang=js&"
export * from "./ModuleClients.vue?vue&type=script&lang=js&"
import style0 from "./ModuleClients.vue?vue&type=style&index=0&id=226f1190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f1190",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
